export const HEART_BEAT = "HEART_BEAT";